var map = {
	"./abc.txt": 2,
	"./included.jade": 5,
	"./parent.jade": 6,
	"./script.coffee": 8,
	"./template.jade": 7
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;



/*****************
 ** WEBPACK FOOTER
 ** ./loaders/_resources ^\.\/.*$
 ** module id = 1
 ** module chunks = 0
 **/